import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import DraftForm from '../DraftForm/DraftForm';

class DraftModalContent extends PureComponent {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { modal: props.initialOpen };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.initialOpen !== this.props.initialOpen) {
      this.setState({ modal: nextProps.initialOpen });
    }
  }

  toggle() {
    const { onCloseModal } = this.props;
    this.setState(prevState => {
      onCloseModal(!prevState.modal);
      return {
        modal: !prevState.modal,
      };
    });
  }

  render() {
    const {
      drafts,
      user: { name },
      onSubmit,
    } = this.props;
    return (
      <div>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          onClose={this.toggle}
          centered
        >
          <ModalBody className="py-4 px-5">
            <div className="row mb-5">
              <div className="col-12 text-right pb-2 mb-3 border-bottom">
                <i
                  onClick={this.toggle}
                  className="icon icon-close text-gray-2 t-20 cursor-pointer"
                />
              </div>
              <div className="col text-left">
                <h2 className="t-34 font-weight-bold">Upload A Draft</h2>
                <p className="t-14 font-weight-mid">
                  {name} is waiting for your next draft. Upload your video to
                  Wipster and submit a link below.
                </p>
              </div>
            </div>
            <div className="row">
              <DraftForm
                drafts={drafts}
                onSubmit={onSubmit}
                handleCloseModal={this.toggle}
              />
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

DraftModalContent.propTypes = {
  drafts: PropTypes.array,
  user: PropTypes.shape({
    name: PropTypes.string,
  }),
  onSubmit: PropTypes.func,
  initialOpen: PropTypes.bool,
  onCloseModal: PropTypes.func,
};

DraftModalContent.defaultProps = {
  initialOpen: false,
};

export default DraftModalContent;



// WEBPACK FOOTER //
// ./src/components/ProjectView/DraftModal/DraftModal/DraftModalContent.js